module.exports = __webpack_public_path__ + "static/media/home-setup-1.2e254ca6.jpg";